import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    IconButton,
    Stack,
    Box,
    useTheme,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import DownloadIcon from "@mui/icons-material/Download";

interface ModalPDFViewerProps {
    open: boolean;
    onClose: () => void;
    base64: string | null;
    filename?: string;
}

export function ModalPDFViewer({
    open,
    onClose,
    base64,
    filename = "documento.pdf",
}: ModalPDFViewerProps) {

    const theme = useTheme();

    const handleDownload = () => {
        const link = document.createElement("a");
        link.href = `data:application/pdf;base64,${base64}`;
        link.download = filename;
        link.click();
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="lg"
            PaperProps={{
                sx: {
                    borderRadius: 2,
                    maxWidth: "98vw",   // impede modal gigante demais
                    width: "70vw",
                    overflow: "hidden", // remove scroll extra
                },
            }}
        >
            {/* HEADER */}
            <DialogTitle
                sx={{
                    background: theme.palette.grey[100],
                    borderBottom: `1px solid ${theme.palette.divider}`,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    pr: 5,
                }}
            >
                <Stack direction="row" alignItems="center" spacing={2}>
                    <PictureAsPdfIcon color="error" />
                    Visualização do orçamento
                </Stack>

                <IconButton
                    onClick={onClose}
                    sx={{ position: "absolute", right: 12, top: 12 }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>

            {/* CONTENT sem scroll duplo */}
            <DialogContent
                sx={{
                    p: 0,
                    overflow: "hidden", // impede scroll do Dialog
                    bgcolor: "grey.100",
                }}
            >
                {base64 ? (
                    <iframe
                        title="PDF Viewer"
                        src={`data:application/pdf;base64,${base64}`}
                        style={{
                            width: "100%",
                            height: "calc(100vh - 220px)", // ajuste ideal da área visível
                            border: "none",
                            overflow: "auto",
                        }}
                    />
                ) : (
                    <Box p={3}>Arquivo inválido.</Box>
                )}
            </DialogContent>

            {/* FOOTER */}
            <DialogActions
                sx={{
                    p: 2,
                    justifyContent: "space-between",
                    borderTop: `1px solid ${theme.palette.divider}`,
                }}
            >
                <Button onClick={onClose}>Fechar</Button>

                <Button
                    variant="contained"
                    startIcon={<DownloadIcon />}
                    color="primary"
                    onClick={handleDownload}
                >
                    Baixar PDF
                </Button>
            </DialogActions>
        </Dialog>
    );
}
